<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { STORAGE_KEYS } from '@/enums/StorageEnum'
import { isNotBlank } from '@/utils/String'

interface Item {
  id: string | number
  content: string
}

const { t } = useI18n()
const emit = defineEmits<(e: 'order-saved', order: (string | number)[]) => void>()

const open = ref(false)
const itemsToReorder = ref<Item[]>([])

const openModal = (items: Item[]) => {
  if (items.length) {
    const storedValue = localStorage.getItem(STORAGE_KEYS.LIVE_VIRTUAL_AGENTS)
    const savedData = JSON.parse(isNotBlank(storedValue) ? storedValue : '{}') as {
      agents?: (string | number)[]
    }

    const savedOrder = savedData.agents ?? []

    if (savedOrder.length) {
      const ordered = savedOrder
        .map((savedId) => items.find((i) => i.id === savedId))
        .filter(Boolean) as Item[]

      const newOnes = items.filter((i) => !savedOrder.includes(i.id))

      itemsToReorder.value = [...ordered, ...newOnes]
    } else {
      itemsToReorder.value = items
    }
  }

  open.value = true
}

const closeModal = () => {
  open.value = false
  return true
}

const saveOrder = () => {
  const order = itemsToReorder.value.map((item) => item.id)
  localStorage.setItem(STORAGE_KEYS.AGENTS_ORDER, JSON.stringify(order))
  emit('order-saved', order)
  open.value = false
  return true
}
</script>

<template>
  <div>
    <OModal
      v-model:open="open"
      data-testid="drag-modal"
      :secondary-action-title="t('cancel')"
      :primary-action-title="t('save')"
      primary-action-enabled
      secondary-action-enabled
      :secondary-action-promise="closeModal"
      :primary-action-promise="saveOrder"
      closable
      :title="t('rearrange_widgets')"
      size="medium"
    >
      <template #content>
        <div class="mb-6 mt-4">
          <ODraggableRow v-model="itemsToReorder" />
        </div>
      </template>
    </OModal>

    <slot :handle-click="openModal" />
  </div>
</template>
